export default __webpack_public_path__ + "static/logo1-f0580d449a5c2f1debbfaa49c1226569.jpg";